require('./hireCardAtHomeAbroadStep1.scss');
// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');

// @constants
const { FIRST_STEP } = require('constants/index');
const getCardsPreContractPdfData = require('constants/cardsPreContractualsPdf');
const { AT_HOME_ABROAD_CARD_PRODUCT_ALIAS,
    PRODUCT_HIRING_COMPONENT_ID } = require('constants/hiringProductInformation');
const { GC } = require('constants/flagBasedFeatures');
const {
    DEBIT_AT_HOME_ABROAD_STANDARD,
    DEBIT_AT_HOME_ABROAD_SUBTYPE,
    DEBIT_CARD_TYPE,
} = require('constants/index');

// @ components
const { HireInformation } = require('components/hire/hireInformation/hireInformation');
const HiringProductInformation = require('components/hiringProductInformation/hiringProductInformation');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const PreContractualMailInfo = require('components/contactCenter/preContractualMailInfo/preContractualMailInfo');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');

class HireCardAtHomeAbroadStep1 extends React.Component {

    componentDidMount() {
        const {
            requestPDFMerge,
            setTermsAndCondsText,
        } = this.props;

        if (!__CONTACT_CENTER__) {
            const pdfurls = getCardsPreContractPdfData()['at_home_abroad_card'].preContractPdfLink;
            const product = {
                standard: DEBIT_AT_HOME_ABROAD_STANDARD,
                subtype: DEBIT_AT_HOME_ABROAD_SUBTYPE,
                type: DEBIT_CARD_TYPE,
            };
            requestPDFMerge(pdfurls, [product]);
        } else if (!!setTermsAndCondsText) {
            //This action is also called in the last step of the current hiring, if you update one remeber that maybe you should update the other one
            setTermsAndCondsText('hireCardAtHomeAbroad-step4CheckboxText');
        }
    }

    buildLegalConfirmationSection() {
        const { immHireInformation, immHiringProductInformation, gestorCrossEnabled } = this.props
        const information = gestorCrossEnabled ? immHiringProductInformation.get('cmsResponse') : immHireInformation.get('information');
        if (!information) return null

        const {
            contractName,
            handleAgreementCheckboxChange,
            immHireCardAtHomeAbroad,
            immPreContractualMail,
            immProfileFields,
            requestProfile,
            sendMailParams,
            sendPreContractualMail
        } = this.props;

        const clientEmail = PersonalDataHelper.getEmail(immProfileFields);
        const profileError = immProfileFields.get('error');
        const immStep = immHireCardAtHomeAbroad.getIn(['steps', FIRST_STEP]);
        const agreementLabel = (
            <FormattedText
                value="hireCardAtHomeAbroad-step4CheckboxText"
                injectedStrings={[immHireCardAtHomeAbroad.getIn(['steps', FIRST_STEP, 'precontractualLinkInfo', 'url'])]}
            />
        )
        const agreementChecked = immStep.get('agreementChecked');
        const agreementErrorVisible = immStep.get('agreementIsDirty') && !immStep.get('agreementChecked');
        const agreementErrorMsg = formatText('hireCardAtHomeAbroad-step4CheckboxErrorMsg');
        const hasBeenEmailSent = immPreContractualMail.get('mailSent');

        return (
            <section className="hire-card-at-home-abroad-step-one__legal-confirmation-section">
                <PreContractualMailInfo
                    contractName={contractName}
                    email={clientEmail}
                    preContractualMail={immPreContractualMail}
                    profileError={profileError}
                    requestProfile={requestProfile}
                    sendEmail={sendPreContractualMail}
                    sendMailParams={sendMailParams}
                />
                <div className="hire-card-at-home-abroad-step-one__checkbox-container">
                    <OKCheckbox
                        idName="hireCardAtHomeAbroadAgreementCheckbox"
                        errorState={agreementErrorVisible}
                        errorMessage={agreementErrorMsg}
                        label={agreementLabel}
                        onChange={handleAgreementCheckboxChange}
                        value={agreementChecked}
                        disabled={!hasBeenEmailSent}
                    />
                </div>
            </section>
        );
    }

    render() {
        const { immHireInformation, gestorCrossEnabled, flagBasedFeatures } = this.props;
        const legalConfirmationSectionCC = __CONTACT_CENTER__ ? this.buildLegalConfirmationSection() : null;
        let productInformationComponent;
        if (gestorCrossEnabled && flagBasedFeatures.get(GC)) {
            productInformationComponent = (
                <React.Fragment>
                    <HiringProductInformation
                        productAlias={AT_HOME_ABROAD_CARD_PRODUCT_ALIAS}
                        productComponentId={PRODUCT_HIRING_COMPONENT_ID}
                    />
                    <ContactCenterRender>
                        {legalConfirmationSectionCC}
                    </ContactCenterRender>
                </React.Fragment>
            )
        } else {
            productInformationComponent = (
                <article className="hire-card-at-home-abroad__step-one">
                    <FormattedText
                        className="hire-card-at-home-abroad__step-title"
                        value="hireCardAtHomeAbroad-step1Title"
                    />
                    <HireInformation
                        hireCmsKey={this.props.hireCmsKey}
                        immHireInformation={immHireInformation}
                    />
                    <ContactCenterRender>
                        {legalConfirmationSectionCC}
                    </ContactCenterRender>
                </article>
            )
        }
        return (
            <div>
                {productInformationComponent}
            </div>
        );
    }
}

HireCardAtHomeAbroadStep1.propTypes = {
    flagBasedFeatures: PropTypes.object.isRequired,
    gestorCrossEnabled: PropTypes.bool,
    hireCmsKey: PropTypes.string.isRequired,
    immHireInformation: PropTypes.object.isRequired,
    immHiringProductInformation: PropTypes.object.isRequired,
    contractName: PropTypes.string,
    handleAgreementCheckboxChange: PropTypes.func,
    immHireCardAtHomeAbroad: PropTypes.object,
    immPreContractualMail: PropTypes.object,
    immProfileFields: PropTypes.object,
    requestPDFMerge: PropTypes.func.isRequired,
    requestProfile: PropTypes.object,
    sendMailParams: PropTypes.object,
    sendPreContractualMail: PropTypes.func,
    setTermsAndCondsText: PropTypes.func,
};

module.exports = HireCardAtHomeAbroadStep1;
